export default __webpack_public_path__ + "static/media/bg_desc_small_food.c12ac8d8.jpg";